class OrderApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  postOrder = async (params) => {
    const res = await this.ctx.post(`/order/`, params)

    return res.data
  }

  getOrders = async (params) => {
    const res = await this.ctx.get('/order/',params)

    return res.data
  }


}

export default OrderApi
